import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden bg-gray-100" data-id="element-91">
      <div className="relative z-10 max-w-6xl mx-auto px-6 flex flex-col items-center" data-id="element-92">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="max-w-4xl text-center flex flex-col items-center mb-16 md:mb-24" data-id="element-93">
          <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-slate-900 leading-[1.1] tracking-tight mb-6" data-id="element-94">
            A next gen operations partner built for your brokerage
          </motion.h1>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-slate-900/70 max-w-2xl mb-10 leading-relaxed" data-id="element-95">
            We combine the speed of AI automation with the accuracy of health
            insurance experts to reliably complete brokerage workflows like
            group installs, employee changes, quoting, & Employee Navigator
            updates.
          </motion.p>

          <motion.div variants={itemVariants} data-id="element-96">
            <a href="" // TODO
          target="_blank" rel="noopener noreferrer" className="inline-block bg-slate-800 text-gray-50 px-14 py-3.5 font-medium text-sm tracking-widest uppercase transition-transform active:scale-95 hover:bg-slate-900 shadow-lg shadow-slate-900/20 no-underline rounded-md" data-id="element-97">
              Schedule a Call
            </a>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full rounded-2xl md:rounded-3xl border border-gray-300/60 shadow-2xl shadow-slate-950/10 overflow-hidden bg-white/50 backdrop-blur-sm p-2 md:p-4" data-id="element-98">
          <div className="relative w-full aspect-video rounded-xl md:rounded-2xl overflow-hidden bg-slate-950 border border-gray-200/50" data-id="element-99">
            <video src="https://cdn.magicpatterns.com/uploads/jcQAUxAnwBw6Tm1Vd7FrCV/mach%20hero.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-100" />
          </div>
        </motion.div>
      </div>
    </section>;
}